import { ZoneWrapper } from 'pages/Map/components/ZoneItem/ZoneItem.styled';
import styled from 'styled-components';

export const MapContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1.6rem;
`;

export const MapsSubHeader = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 1rem;
    @media (max-width: ${({ theme }) => theme.breakpoints.S.max}px) {
        flex-direction: column;
    }
`;

export const MapZones = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 2.4rem;

    ${ZoneWrapper} {
        @media (max-width: ${({ theme }) => theme.breakpoints.S.max}px) {
            max-width: 100%;
        }
    }
`;
